import { render, staticRenderFns } from "./ExportPerformanceReport.vue?vue&type=template&id=07c203f8&"
import script from "./ExportPerformanceReport.vue?vue&type=script&lang=js&"
export * from "./ExportPerformanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports